import React from 'react';
import ScrollTabs from '@home/pages/studio/components/ScrollTabs';
import SvgIcon from '@home/components/SvgIcon';
import { getName } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import { useIntl } from 'umi';
import './index.scss';
import classNames from 'classnames';
import CommonBubble from '@home/components/CommonBubble';
import { getBasePath } from '@/utils/utils';

interface IOpinionsScrollTabsProps {
  reportUrl: string;
  textEn?: string;
  textCn?: string;
  [key: string]: any;
}
const OpinionsScrollTabs = (props: IOpinionsScrollTabsProps) => {
  const {
    reportUrl,
    textEn = 'Reports',
    textCn = '报告',
    explainEn = 'Jump to sentiment reports',
    explainCn = '跳转至舆情报告',
    ...reseProps
  } = props || {};

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  
  const btnText = getName(isEn, textEn, textCn);
  const explain = getName(isEn, explainEn, explainCn);

  const openNewLink = () => {
    window.open(`${getBasePath()}${reportUrl}`);
  };

  return (
    <div className={classNames('dbh-opinions-scrollTabs-container')}>
      <ScrollTabs
        {...reseProps}
        afterDom={
          reportUrl && (
            <CommonBubble content={explain}>
              <div
                className="dbh-opinions-scrollTabs-btn"
                onClick={openNewLink}
              >
                <i>
                  <SvgIcon type="action-reports-icon" />
                </i>
                <div>{btnText}</div>
              </div>
            </CommonBubble>
          )
        }
      />
    </div>
  );
};

export default OpinionsScrollTabs;
